<template>
  <div class="modal-captcha">
    <div class="captcha-title">
      <span class="gradient-green">{{ $t('modal.24') }}</span>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    
 
    export default {
        name: 'ModalTip',
        components: {
            
        },
       
       methods: {
    ...mapActions([
        'modalsSetShow', 
        'authSendCredentialsLogin',
        'authSendCredentialsRegister',
        'authSendCredentialsRequest',
        'authSendCredentialsReset',
        'affiliatesSendClaimCodeSocket', 
        'generalSendPromoClaimSocket', 
        'cashierSendGiftRedeemSocket', 
        'generalSendRainJoinSocket'
    ]),

    submitWithoutCaptcha() {
        const data = { ...this.modalsData.data };

        if (this.modalsData.typeCaptcha === 'credentialsLogin') {
            this.authSendCredentialsLogin(data);
        } 
        else if (this.modalsData.typeCaptcha === 'credentialsRegister') {
            this.authSendCredentialsRegister(data);
        } 
        else if (this.modalsData.typeCaptcha === 'credentialsRequest') {
            this.authSendCredentialsRequest(data);
        } 
        else if (this.modalsData.typeCaptcha === 'credentialsReset') {
            this.authSendCredentialsReset(data);
        } 
        else if (this.modalsData.typeCaptcha === 'affiliatesClaim') {
            this.affiliatesSendClaimCodeSocket(data);
        } 
        else if (this.modalsData.typeCaptcha === 'promoClaim') {
            this.generalSendPromoClaimSocket(data);
        } 
        else if (this.modalsData.typeCaptcha === 'giftRedeem') {
            this.cashierSendGiftRedeemSocket(data);
        } 
        else if (this.modalsData.typeCaptcha === 'rainJoin') {
            this.generalSendRainJoinSocket(data);
        }

        this.modalsSetShow(null);
    }
},

        computed: {
            ...mapGetters([ 
                'modalsData'
            ])
        },
        mounted() {
    this.submitWithoutCaptcha();
}

    }
</script>

<style scoped>
.modal-captcha {
    width: 773px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0 48px 0;
    border-radius: 15px;
    background: var(--background);
}

.modal-captcha .captcha-title {
    text-align: center;
    font-size: 32px;
    font-weight: 900;
}

.modal-captcha .captcha-content {
    width: 303px;
    height: 76px;
    margin-top: 35px;
    border-radius: 4px;
    background-color: #1a4f63;
}

/* Tablet */
@media only screen and (max-width: 793px) {
    .modal-captcha {
        width: calc(100vw - 20px);
        padding: 85px 20px 48px 20px;
    }
}

/* Mobil (bottom sheet) */
@media only screen and (max-width: 500px) {
    .modal-captcha {
        width: 100vw;                  /* tam genişlik */
        max-width: 100%;
        border-radius: 20px 20px 0 0;  /* sadece üst köşeler yuvarlak */
        padding: 85px 15px 48px 15px;  /* kenarlarda eşit boşluk */
    }
}
</style>

